// All application state names should be configured here
export const AppStateModuleName = {
  article: 'articleState',
  home: 'homeState'
}
